export class SubHeader {
    public title: string;
    public showBreadCrumbs: boolean;
    public buttons: any[];

    constructor(data: any) {
        this.title = data.title;
        this.showBreadCrumbs = data.showBreadCrumbs;
        this.buttons = data.buttons;
    }
}